import { useEffect, useState } from 'preact/hooks';

export type AsyncState<T> =
    | { status: 'idle' }
    | { status: 'loading' }
    | { status: 'success'; data: T }
    | { status: 'error'; error: Error };

export function useFetch<T>(fetcher: () => Promise<T>, deps: unknown[] = []): AsyncState<T> {
    const [state, setState] = useState<AsyncState<T>>({ status: 'idle' });

    useEffect(() => {
        let cancelled = false;
        setState({ status: 'loading' });
        fetcher()
            .then((data) => {
                if (!cancelled) setState({ status: 'success', data });
            })
            .catch((error: unknown) => {
                if (!cancelled) {
                    setState({
                        status: 'error',
                        error: error instanceof Error ? error : new Error(String(error)),
                    });
                }
            });
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return state;
}
